import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import HeroSection from "./HeroSection";
import WhereLanguageMeets from "./WhereLanguageMeets";
import CommonUseCases from "./CommonUseCases";
import TrustBanner from "./TrustBanner";

const UseCasesAndSolutions = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    window.scrollTo(0, 0);
    document.title = "Multilingual Solutions & Use Cases | NKENNE AI";
  }, []);

  return (
    <div className="flex flex-col w-full relative bg-white space-y-16 sm:space-y-24 pb-16 sm:pb-24">
      <HeroSection />
      <WhereLanguageMeets />
      <CommonUseCases />
      <TrustBanner />
    </div>
  );
};

export default UseCasesAndSolutions;
